import { RouterProvider } from "react-router-dom"
import { router } from "./presentation/layouts/routes"


function App() {
  return (
    <RouterProvider router={router} />
  )
}

export default App
